import { render, staticRenderFns } from "./ResidentMapping.vue?vue&type=template&id=dd15b732"
import script from "./ResidentMapping.vue?vue&type=script&lang=js"
export * from "./ResidentMapping.vue?vue&type=script&lang=js"
import style0 from "./ResidentMapping.vue?vue&type=style&index=0&id=dd15b732&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports